import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { FormGroup, FormBuilder, Validators, AbstractControl } from '@angular/forms';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { ActivatedRoute, Router } from '@angular/router';
import { CompetenceProvider } from "../../../shared/providers/enums/billing-letter/competence-provider";
import { PurchaseOrderService } from '../../../services/purchaseOrder.service';
import { CnaeService } from '../../../services/cnae.service';
import { LocalStorage } from '../../../shared/wrappers/LocalStorage';
import { DropdownItemFactory } from '../../../shared/factories/dropdown/dropdown-item.factory';
import { DropdownSettingsFactory } from '../../../shared/factories/dropdown/dropdown-settings.factory';
import { CompaniesService } from '../../../services/companies.service';
import { ConsultantService } from '../../../services/consultant.service';
import { ProjectFinancialService } from '../../../services/projectFinancial.service';
import { Dimension, PurchaseOrder, PurchaseOrderRecurrence, Ratio } from '../../../models/PurchaseOrder.model';
import { SapItemType } from '../../../shared/enums/SapItemType';
import { CommonHelper } from '../../../shared/helpers/CommonHelper';
import * as _ from 'lodash';
import * as moment from 'moment';
import { CompanyService } from "../../../services/billing-letter/company.service";
import { ErrorHandlerProvider } from '../../../shared/providers/errorHandler.provider';
import { AccountingPeriodBlock } from '../../../models/AccountingPeriodBlock.model';
import { AccountingPeriodBlockService } from '../../../services/accountingBlock.service';
import { isBlockPeriodInvalid } from '../../../shared/helpers/validate-block-period';
import { AccountingType } from '../../../shared/enums/AccountingBlockType';
import { PurchaseOrderType } from '../../../shared/enums/PurchaseOrderType';

@Component({
    selector: 'app-purchase-order-create',
    templateUrl: './purchase-order-create.component.html',
    styleUrls: ['./purchase-order-create.component.css']
})
export class PurchaseOrderCreateComponent implements OnInit {
    @ViewChild("openModalRecurrent") openModalRecurrent: ElementRef;
    purchaseForm: FormGroup;
    loading: boolean;
    commonHelper: CommonHelper = new CommonHelper();
    competences = this.competenceProvider.competences;
    competenceYears = this.commonHelper.listLastYears();
    datePickerOptions = this.commonHelper.getDatePickerOptions();
    purchaseOrder: PurchaseOrder = new PurchaseOrder();
    consultants: any[] = new Array<any>();
    companies: any[] = new Array<any>();
    customers: any[] = new Array<any>();
    projects: any[] = new Array<any>();
    itemNotFound: boolean = false;
    showDefaultItems: boolean = false;
    purchaseOrderRecurrent: Boolean = false;
    valueAux: number = 0;
    percentAux: number = 0;
    loggedUser;
    eaPurchaseOrder: boolean = true;
    apportionment: any = {};
    valueTotalQuantity;

    dropDownCompanies: any;
    groups: Array<any> = [];

    items = [];
    itemsPurchaseOrder = [];
    itemAux: any = {
        sapItemCode: '',
        itemName: '',
        customer: {},
        project: {},
        percentage: 0,
        quantity: 1,
        value: 0
    }

    itemsDropdown = {
        list: [], options: null, selected: []
    };
    defaultItemsDropdown = {
        list: [], options: null, selected: []
    };
    companiesDropdown = {
        list: [], options: null, selected: []
    };
    customersDropdown = {
        list: [], options: null, selected: []
    };
    projectsDropdown = {
        list: [], options: null, selected: []
    };
    companyGroupDropdown = {
        list: [], options: null, selected: []
    };
    purchaseOrderTypeDropdown = {
        list: [], options: null, selected: []
    };

    recurrenceList = [] as PurchaseOrderRecurrence[];
    recurrentAux = {
        competence: 0,
        competenceYear: 0,
        dueDate: new Date(),
        recurrent: 1,
        value: 0,
    } as PurchaseOrderRecurrence;

    accountingBlock = new AccountingPeriodBlock();
    purchaseOrderTypeModels = new PurchaseOrder()
    isBlanketAgreement;
    datePickerStart: string = "";
    datePickerEnd: string = "";
    notAllowedToAddItem = true;
    objectApportionment: any;

    constructor(
        private formBuilder: FormBuilder,
        private competenceProvider: CompetenceProvider,
        private purchaseService: PurchaseOrderService,
        private cnaeService: CnaeService,
        private dropDownItemFactory: DropdownItemFactory,
        private dropDownSettingFactory: DropdownSettingsFactory,
        private companyService: CompanyService,
        private companiesService: CompaniesService,
        private consultantService: ConsultantService,
        private projectFinancialService: ProjectFinancialService,
        private localStorage: LocalStorage,
        private router: Router,
        public toastr: ToastsManager,
        private errorHandler: ErrorHandlerProvider,
        private accountingBlockService: AccountingPeriodBlockService,
        private route: ActivatedRoute,

    ) { }

    async ngOnInit() {
        this.loading = true;
        this.accountingBlock = (await this.accountingBlockService.getAllBlockedPeriods())
        .find(({type}: AccountingPeriodBlock) => type === AccountingType.PurchaseOrder);

        this.purchaseForm = this.formBuilder.group({
            value: [null, Validators.required],
            requester: [null, [this.validateSelectOptionRequester]],
            competence: [null, [this.validateSelectOption]],
            competenceYear: [null, [this.validateSelectOption]],
        });

        this.loggedUser = this.localStorage.retrieve('user');
        this.purchaseOrder.requester.name = this.loggedUser.name;
        this.purchaseOrder.dueDate = new Date();

        this.companies = await this.companiesService.listVendors();
        const vendors = _.cloneDeep(this.companies);
        this.companies = this.companies.map(company => ({ ...company, name: company.companyName }));

        this.consultants = await this.consultantService.listAll(false);
        this.consultants = this.consultants
            .filter(consultantFilter => consultantFilter.sapCardCode &&
                                        consultantFilter.contract &&
                                        consultantFilter.contract.kind == 1)
            .map(consultantMap => {
                return {
                    _id: consultantMap._id,
                    name: consultantMap.contract.companyName,
                    cnpj: consultantMap.contract.cnpj,
                    sapCardCode: consultantMap.sapCardCode
                }
            });

        const projectsAndCustomer = await this.projectFinancialService.getProjectsAndCustomers();
        const companyGroupWithCustomer = await this.companyService.getCompanyGroupsWithCustomer();
        this.customers = companyGroupWithCustomer.customers;
        this.groups = companyGroupWithCustomer.groups;
        this.projects = projectsAndCustomer.projects;

        this.items = await this.cnaeService.getAllItems([SapItemType.ItemPurchaseOrder]);
        this.items = _.orderBy(this.items,[item => item.name.toUpperCase()]);

        let vendorsDropdownAux = this.dropDownItemFactory.build({source:this.companies});
        vendorsDropdownAux = vendorsDropdownAux.map(vendor => ({ ...vendor, type: 'Fornecedor - Razão Social' }));

        let vendorsDropdownName = this.dropDownItemFactory.build({source:vendors});
        vendorsDropdownName = vendorsDropdownName.map(vendor => ({ ...vendor, type: 'Fornecedor - Nome Fantasia' }));

        let consultantDropdownAux = this.dropDownItemFactory.build({source:this.consultants});
        consultantDropdownAux = consultantDropdownAux.map(consultant => ({ ...consultant, type: 'Fornecedor - Consultor PJ' }));

        this.companiesDropdown.options = this.dropDownSettingFactory.build({text:'Fornecedores',singleSelection:true,enableCheckAll:false,groupBy:'type'});
        this.companiesDropdown.list = vendorsDropdownAux.concat(consultantDropdownAux, vendorsDropdownName)

        this.companyGroupDropdown.list = this.commonHelper.getDropDownListItems(this.groups, "_id", "name");
        this.companyGroupDropdown.options = this.dropDownSettingFactory.build({text:'Grupos de empresa',singleSelection:true,enableCheckAll:false});

        this.purchaseOrderTypeDropdown.list = this.commonHelper.getDropDownListItemsEnum(this.commonHelper.getAllPurchaseOrderType(), "PurchaseOrderType");
        this.purchaseOrderTypeDropdown.options = this.commonHelper.getDropDownSettings(true, 'Tipo', true, "", "", true,null, '');

        this.customersDropdown.options = this.dropDownSettingFactory.build({text:'Clientes',singleSelection:true,enableCheckAll:false});
        this.customersDropdown.options["disabled"] = true;
        this.customersDropdown.list = this.dropDownItemFactory.build({source:this.customers});
        this.projectsDropdown.options = this.dropDownSettingFactory.build({text:'Projetos',singleSelection:true,enableCheckAll:false});
        this.projectsDropdown.options["disabled"] = true;
        this.projectsDropdown.list = this.dropDownItemFactory.build({source:this.projects});

        this.itemsDropdown.options = this.dropDownSettingFactory.build({text:'Item do pedido',singleSelection:true,enableCheckAll:false});
        this.itemsDropdown.options["disabled"] = true;

        this.defaultItemsDropdown.options = this.dropDownSettingFactory.build({text:'Itens pré-selecionados',singleSelection:true,enableCheckAll:false});
        this.defaultItemsDropdown.options["disabled"] = true;

        this.itemsDropdown.list = this.dropDownItemFactory.build({source:this.items});

        if(this.accountingBlock && this.accountingBlock.competenceYear &&
            this.accountingBlock.competence){
             this.datePickerOptions.minDate = new Date(this.accountingBlock.competenceYear,this.accountingBlock.competence,1);
        }

        //Load Purchase Order dropdowns and items
        if (!_.isEmpty(this.route.snapshot.queryParams)) {
            this.buildCompaniesAndVendorInputs();
            this.buildItemsAndBlanketAgreementFields();
            this.sendModalApportionment();
        };
        this.loading = false;
    }

    buildCompaniesAndVendorInputs(): void {
        const selectedCompany = this.companiesDropdown.list.find((comp) => {
            return this.purchaseOrder.company._id == comp.id
        });
        this.companiesDropdown.selected.push({
            ...selectedCompany,
            id: selectedCompany.id
        });
        this.changeCompany();
    }

    buildItemsAndBlanketAgreementFields(): void {
        this.itemsPurchaseOrder = [...this.purchaseOrder.items];
        if (!this.purchaseOrder.isBlanketAgreement) {
            this.purchaseOrderTypeDropdown.selected.push(...this.commonHelper.getDropDownListItemsEnum([1], "PurchaseOrderType"))
            this.itemsPurchaseOrder.forEach((_, index) => {
                this.itemsPurchaseOrder[index] = {
                    ...this.itemsPurchaseOrder[index],
                    percentage: 0
                }
                this.changeValue(index);
            });
        } else {
            this.purchaseOrderTypeDropdown.selected.push(...this.commonHelper.getDropDownListItemsEnum([2], "PurchaseOrderType"))
            this.isBlanketAgreement = true;
            this.itemsPurchaseOrder.forEach((_, index) => {
                this.itemsPurchaseOrder[index] = {
                    ...this.itemsPurchaseOrder[index],
                    percentage: 0
                }
                this.changeValue(index);
                this.changeQuantity(index);
            });
            this.changeTotalValue();
            this.datePickerStart = new Date(this.purchaseOrder.startDate).toISOString().slice(0, 7) || "";
            this.datePickerEnd = new Date(this.purchaseOrder.endDate).toISOString().slice(0, 7) || "";
        }
    }

    changePurchaseOrderType(){
        this.clearItemAux();
        if (!this.purchaseOrderTypeDropdown.selected[0] || !this.purchaseOrderTypeDropdown.selected[0].id) return;
        if(Number(this.purchaseOrderTypeDropdown.selected[0].id) == PurchaseOrderType.PurchaseOrder){
            this.purchaseOrder.isBlanketAgreement = false
            this.isBlanketAgreement = false;
            return;
        }
        this.purchaseOrder.isBlanketAgreement = true
        this.isBlanketAgreement = true;
    }

    async save(){
        try{
            if(!this.isBlanketAgreement && Number(this.purchaseOrder.paymentMethod) == 0) {
                this.toastr.warning('É obrigatório o preenchimento da Forma de Pagamento');
                return;
            }

            for(let i of this.itemsPurchaseOrder) {
                if(!i.value || i.value == 0){
                    this.toastr.warning('Todos os itens precisam ter valores atribuídos');
                    return;
                }
            }

            if (!this.purchaseOrderRecurrent && !this.isBlanketAgreement) {
                if(Number(this.purchaseOrder.competence) == 0 || Number(this.purchaseOrder.competenceYear) == 0) {
                    this.toastr.warning('Verifique se preencheu corretamente todos os campos obrigatórios', 'Erro ao salvar Pedido de Compra');
                    return;
                }
            }

            if(this.purchaseOrderRecurrent && this.recurrenceList.length > 0) {
                for(let recurrence of this.recurrenceList)
                    if(recurrence.competence == 0 || recurrence.competenceYear == 0 || !recurrence.dueDate) {
                        this.toastr.warning('Todos os dados da recorrência precisam ser preenchidos!', 'Recorrência inválida');
                        return;
                    }
            }

            if(this.valueTotalQuantity !== this.purchaseOrder.value){
                this.toastr.warning('A soma dos valores rateados nos itens e/ou eixos não correspondem com o valor total do pedido', 'Rateio inválido')
                return;
            }

            let companyAux = this.companies.find(c => c._id === this.purchaseOrder.company._id);
            if(!companyAux)
                companyAux = this.consultants.find(c => c._id === this.purchaseOrder.company._id);
            if(!companyAux) {
                this.toastr.warning('Fornecedor é obrigatório'); return;
            }

            if(this.invalidApportionment()) {
                this.toastr.warning(
                    "Se ao menos uma das linhas de itens do pedido de compra não possuir um rateio personalizado, é obrigatório o preenchimento do Rateio de Eixos geral do pedido", "Rateio de eixos inválido",
                    { dismiss: 'controlled' }
                ).then((t) => { setTimeout(() => { this.toastr.dismissToast(t) }, 10000) });
                return;
            }

            //associação de competencia no pedido guarda-chuva - desenvolvimento paliativo
            if(this.purchaseOrder.isBlanketAgreement) {
                if(!this.purchaseOrder.startDate || !this.purchaseOrder.endDate) {
                    return this.toastr.warning('As datas inicial e final são obrigatórias no pedido guarda chuva');
                } else if(this.purchaseOrder.endDate < this.purchaseOrder.startDate) {
                    return this.toastr.warning('A data final deve ser maior que a data de início do pedido de compra guarda chuva');
                }

                const [competenceYear, competence] = this.datePickerStart.split('-')
                this.purchaseOrder.competence = Number(competence);
                this.purchaseOrder.competenceYear = Number(competenceYear);
            }

            if(this.purchaseOrder.competenceYear && this.purchaseOrder.competence &&
                this.purchaseOrder.competenceYear != 0 && this.purchaseOrder.competence != 0) {
                const isInvalid = isBlockPeriodInvalid({
                    competence: this.purchaseOrder.competence,
                    competenceYear: this.purchaseOrder.competenceYear
                }, this.accountingBlock)
                if (isInvalid) {
                    return this.toastr.warning(`A competência ${this.competenceProvider.findCompetence(this.purchaseOrder.competence)}/${this.purchaseOrder.competenceYear}, está dentro do intervalo de bloqueio. Por favor selecione uma data diferente antes de cadastrar o pedido.`, 'Bloqueio Contábil', {
                        toastLife:8000,
                        showCloseButton: true
                    });
                }
            }

            this.purchaseOrder.company.sapCardCode = companyAux ? companyAux.sapCardCode : '';
            this.purchaseOrder.company.name = companyAux ? companyAux.name : '';
            this.purchaseOrder.company.cnpj = companyAux ? companyAux.cnpj : '';
            this.purchaseOrder.items = this.itemsPurchaseOrder;

            this.loading = true;
            let response;
            if(this.purchaseOrderRecurrent && this.recurrenceList.length > 0) {
                const purchaseOrders = this.buildRecurrencePurchaseOrder(this.recurrenceList);
                response = await this.purchaseService.createRecurrence(purchaseOrders, this.purchaseOrder.value);
                this.loading = false;
                if(response && response.length > 0){
                    if(response[0].status == 400 || response[0].status == 500){
                        this.errorHandler.interceptError(response[0], 'Pedido de Compra');
                    } else {
                        this.toastr.success(`Os ${this.recurrenceList.length} pedidos de compra recorrentes foram criados com sucesso`);
                        this.router.navigate(['/purchase-orders']);
                    }
                }
            } else {
                response = await this.purchaseService.create(this.purchaseOrder);
                this.loading = false;
                if(response._id){
                    this.toastr.success('Pedido de Compra criado com sucesso');
                    this.router.navigate(['/purchase-orders']);
                } else {
                    this.errorHandler.interceptError(response, 'Pedido de Compra');
                }
            }

        } catch(err){
            this.loading = false;
            this.toastr.warning('Verifique se preencheu corretamente todos os campos obrigatórios', 'Erro ao salvar Pedido de Compra');
        }
    }

    onDatePickerChange() {
        this.purchaseOrder.startDate = this.datePickerStart ? new Date(`${this.datePickerStart}-01`) : null;
        this.purchaseOrder.endDate = this.datePickerEnd ? new Date(`${this.datePickerEnd}-01`) : null;
        if(this.purchaseOrder.endDate < this.purchaseOrder.startDate){
            this.toastr.warning('A data final deve ser maior que a data de início do pedido de Compra guarda chuva');
            return
        }
    }

    buildRecurrencePurchaseOrder(recurrenceList) {
        let build = [];
        const anticipationCode = this.randomPurchaseJoinGenerator(4);
        const purchaseJoin = this.randomPurchaseJoinGenerator();
        for(let recurrenceItem of recurrenceList) {
            const purchaseOrder = {
                ...this.purchaseOrder,
                value: recurrenceItem.value,
                competence: recurrenceItem.competence,
                competenceYear: recurrenceItem.competenceYear,
                dueDate: recurrenceItem.dueDate,
                purchaseJoin: this.eaPurchaseOrder ? purchaseJoin : '',
                anticipationCode: this.eaPurchaseOrder ? anticipationCode : '',
            }
            build.push(purchaseOrder);
        }
        return build;
    }

    randomPurchaseJoinGenerator = (length = 2) => {
        const letters = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];
        const numbers = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
        let code = '';
        for (let i = 0; i < length; i++) {
            code += letters[Math.floor(Math.random() * 26)];
            code += numbers[Math.floor(Math.random() * 10)];
        }
        return code;
    }

    cancel() {
        this.purchaseOrder = new PurchaseOrder();
        this.purchaseOrder.requester.name = this.loggedUser.name;
        this.companiesDropdown.selected = [];
        this.itemsDropdown.selected = [];
        this.defaultItemsDropdown.selected = [];
        this.itemsPurchaseOrder = [];
    }

    changeVisibleItems(){
        this.itemsDropdown.selected = [];
        this.defaultItemsDropdown.selected = [];
        if(this.itemNotFound){
            this.itemsDropdown.options = { ...this.itemsDropdown.options, disabled: false }
            this.defaultItemsDropdown.options = { ...this.defaultItemsDropdown.options, disabled: true }
        } else {
            this.itemsDropdown.options = { ...this.itemsDropdown.options, disabled: true }
            this.defaultItemsDropdown.options = { ...this.defaultItemsDropdown.options, disabled: false }
        }
    }

    changeCompany(){
        this.itemsDropdown.selected = [];
        this.defaultItemsDropdown.selected = [];
        this.itemsPurchaseOrder = [];
        let listDefaultItems = [];

        //Valida fornecedor aprovado pelo juridico
        // const companySelected = this.companies.find(company => company._id === this.companiesDropdown.selected[0].id);
        // if(companySelected && !companySelected.legalApproved) {
        //     this.toastr.warning('Este Fornecedor não foi aprovado pelo Jurídico.');
        //     this.companiesDropdown.selected = [];
        // }

        if(this.companiesDropdown.selected.length == 0){
            this.purchaseOrder.company._id = '';
        } else {
            this.purchaseOrder.company._id = this.companiesDropdown.selected[0].id;
        }

        const companySelect = this.companies.find(c => c._id === this.purchaseOrder.company._id);
        if(companySelect && companySelect.defaultItems && companySelect.defaultItems.length > 0){
            companySelect.defaultItems.forEach(item => {
                const itemDefault = this.items.find(i => i.sapItemCode === item);
                listDefaultItems.push({
                    id: itemDefault._id,
                    itemName: itemDefault.name,
                    sapItemCode: itemDefault.sapItemCode
                });
            });
        }
        this.defaultItemsDropdown.list = listDefaultItems;
        if(listDefaultItems.length > 0){
            this.showDefaultItems = true;
            this.defaultItemsDropdown.options = { ...this.defaultItemsDropdown.options, disabled: false }
            this.itemsDropdown.options = { ...this.itemsDropdown.options, disabled: true }
        } else {
            this.showDefaultItems = false;
            this.defaultItemsDropdown.options = { ...this.defaultItemsDropdown.options, disabled: true }
            this.itemsDropdown.options = { ...this.itemsDropdown.options, disabled: false }
        }
    }

    changeCustomer() {
        this.projectsDropdown.selected = [];
        if(this.customersDropdown.selected.length > 0){
            const customerId = this.customersDropdown.selected[0].id;
            this.projectsDropdown.list = this.dropDownItemFactory.build({
                source: this.projects.filter(p => p.companyId == customerId)
            });
            this.projectsDropdown.options = { ...this.projectsDropdown.options, disabled: false }
        } else {
            this.projectsDropdown.list = [];
            this.projectsDropdown.options = { ...this.projectsDropdown.options, disabled: true }
        }
    }

    changeCompanyGroup(){
        this.customersDropdown.selected = [];
        this.projectsDropdown.selected = [];
        this.projectsDropdown.list = [];
        if(this.companyGroupDropdown.selected.length > 0) {
            const companyGroupId = this.companyGroupDropdown.selected[0].id;
            this.customersDropdown.list = this.dropDownItemFactory.build({
                source: this.customers.filter(c => c.companyGroup._id == companyGroupId )
            });
            this.customersDropdown.options = { ...this.customersDropdown.options, disabled: false }
        }
        else {
            this.customersDropdown.options = { ...this.customersDropdown.options, disabled: true }
            this.projectsDropdown.options = { ...this.projectsDropdown.options, disabled: true }
        }
    }

    addItem() {
        let itemSelected;
        const customer = this.customersDropdown.selected.length > 0 ? this.customersDropdown.selected[0] : null;
        const project = this.projectsDropdown.selected.length > 0 ? this.projectsDropdown.selected[0] : null;
        const companyGroup = this.companyGroupDropdown.selected.length > 0 ? this.companyGroupDropdown.selected[0] : null;

        if(this.defaultItemsDropdown.selected.length > 0)
            itemSelected = this.items.find(i => i._id === this.defaultItemsDropdown.selected[0].id);
        else if(this.itemsDropdown.selected.length > 0)
            itemSelected = this.items.find(i => i._id === this.itemsDropdown.selected[0].id);

        this.itemsPurchaseOrder.push({
            sapItemCode: itemSelected.sapItemCode,
            itemName: itemSelected.name,
            companyGroup: companyGroup ? { '_id': companyGroup.id, 'name': companyGroup.itemName } : null,
            customer: customer ? { '_id': customer.id, 'name': customer.itemName, 'industry': customer.industry || {} } : null,
            project: project ? { '_id': project.id, 'name': project.itemName } : null,
            percentage: 0,
            quantity: 1,
            value: 0
        });
        this.clearItemAux();
    }

    removeItem(i) {
        let purchaseOrderItem = this.itemsPurchaseOrder[i];
        if (purchaseOrderItem.customer && (purchaseOrderItem.customer.industry && purchaseOrderItem.customer.industry._id)) {
            let itemIndustryId = purchaseOrderItem.customer.industry._id;
            let index = this.purchaseOrder.industries.findIndex(industry => industry._id === itemIndustryId);
            if (index > -1) this.purchaseOrder.industries.splice(index, 1);
        };

        this.itemsPurchaseOrder.splice(i, 1);
    }

    clearItemAux() {
        this.itemsDropdown.selected = [];
        this.defaultItemsDropdown.selected = [];
        this.customersDropdown.selected = [];
        this.projectsDropdown.selected = [];
        this.companyGroupDropdown.selected = [];
        this.itemAux = {
            sapItemCode: '',
            itemName: '',
            customer: {},
            project: {},
            percentage: 0,
            value: 0
        };
    }

    verifyValidTouched(fieldName) {
        return !this.purchaseForm.get(fieldName).valid && this.purchaseForm.get(fieldName).touched;
    }

    validateSelectOption(control: AbstractControl) {
        if (control.value != 0 || control.value != '0')
            return null;
    }

    validateSelectOptionRequester(control: AbstractControl) {
        if (control.value === undefined || control.value == 'undefined')
            return {requester: true};
        return null;
    }

    applyErrorCss(fieldName) {
        return {
            'has-error': this.verifyValidTouched(fieldName)
        }
    }

    changeTotalValue() {
        this.valueTotalQuantity = this.getValuePercentageOfQuantity();
        this.percentAux = this.valueTotalQuantity / this.purchaseOrder.value * 100;
        if (Number.isNaN(this.percentAux)) {
            this.percentAux = 0;
        }
        this.valueAux = this.purchaseOrder.value - this.valueTotalQuantity
    }

    changeValue(i) {
        const percent = this.itemsPurchaseOrder[i].value / this.purchaseOrder.value * 100;
        this.itemsPurchaseOrder[i].percentage = percent;
    }

    changePercent(i) {
        const valuePercent = (this.purchaseOrder.value / 100 * this.itemsPurchaseOrder[i].percentage) * this.itemsPurchaseOrder[i].quantity;
        this.itemsPurchaseOrder[i].value = parseFloat(valuePercent.toFixed(2));
        this.changeTotalValue();
    }

    getValuePercentageOfQuantity() {
        let data = 0
        this.itemsPurchaseOrder.forEach(c => data += (this.purchaseOrder.value / 100 * c.percentage * c.quantity))
        return parseFloat(data.toFixed(2));
    }

    changeQuantity(i) {
        this.purchaseOrder.quantity =  Number(this.itemsPurchaseOrder[i].quantity);
        this.changeTotalValue();

        if(this.valueTotalQuantity > this.purchaseOrder.value){
            this.itemsPurchaseOrder[i].quantity = 0;
            const inputElement = document.getElementById('quantity-' + i.toString()) as any
            inputElement.value = 0
            this.changeTotalValue();
            this.toastr.warning('A soma dos valores nos items não correspondem com o valor total do pedido');
        }
    }

    changePurchaseOrderRecurrent() {
        if(this.purchaseOrderRecurrent) {
            this.recurrentAux = {
                competence: 0, competenceYear: 0, dueDate: new Date(), recurrent: 1, value: 0
            };
            this.openModalRecurrent.nativeElement.click();
            this.notAllowedToAddItem = true;
            this.purchaseOrderTypeDropdown.selected = [];
        } else {
            this.clearRecurrentAux();
        }
    }

    clearRecurrentAux(){
        this.recurrenceList = [];
        this.purchaseOrder.competence = 0;
        this.purchaseOrder.competenceYear = 0;
        this.purchaseOrder.dueDate = new Date();

        if (!_.isEmpty(this.purchaseOrder.anticipation)) {
            delete this.purchaseOrder.anticipation;
        };

        this.purchaseOrderRecurrent = false;
    }

    addRecurrentAux(){
        if(this.purchaseOrderRecurrent && this.purchaseOrder.value > 0 && this.recurrentAux.recurrent > 0) {
            this.purchaseOrder.competence = 0; this.purchaseOrder.competenceYear = 0;
            let competenceAux = this.recurrentAux.competence;
            let competenceYearAux = this.recurrentAux.competenceYear;
            let dueDateAux = this.recurrentAux.dueDate;
            const anticipationValuesArray = this.divideAnticipation(this.purchaseOrder.value, this.recurrentAux.recurrent);
            for(let i=0; i<this.recurrentAux.recurrent; i++) {
                const recurrenceItem = {
                    competence: competenceAux,
                    competenceYear: competenceYearAux,
                    dueDate: new Date(dueDateAux),
                    value: anticipationValuesArray[i]
                };
                this.recurrenceList.push(recurrenceItem);

                competenceAux++;
                if(competenceAux == 13) {
                    competenceAux = 1;
                    competenceYearAux++;
                }
                if(!this.eaPurchaseOrder) dueDateAux.setMonth(dueDateAux.getMonth()+1);
            }
        }
        if (this.recurrenceList.length > 0) {
            this.saveAnticipationDates();
        }
    }

    divideAnticipation(totalValue: number, competences: number): number[] {
        const value = totalValue / competences;
        const formattedValue = value.toFixed(2);
        const formattedValueAsFloat = parseFloat(formattedValue);

        const anticipationTotalValue = formattedValueAsFloat * competences;
        const difference = totalValue - anticipationTotalValue;

        const lastCompetence = parseFloat((formattedValueAsFloat + difference).toFixed(2));
        const anticipationArray = new Array(competences).fill(formattedValueAsFloat);

        //Primeira competência recebe o valor da diferença caso dizima periódica
        anticipationArray[0] = lastCompetence;

        return anticipationArray;
    }

    saveAnticipationDates() {
        let competenceAux = this.recurrentAux.competence;
        let competenceYearAux = this.recurrentAux.competenceYear;
        Object.assign(this.purchaseOrder, {anticipation: {
            startDate: moment(`${competenceYearAux}-${competenceAux}-01`).toISOString(),
            endDate: moment(`${competenceYearAux}-${competenceAux}-01`).add(this.recurrentAux.recurrent - 1, 'months').toISOString()
        }});

    }

    invalidApportionment() {
        const allItemsHaveApportionment = this.itemsPurchaseOrder.every(item => item.hasApportionment);
        if(allItemsHaveApportionment) return false;
        return (!this.purchaseOrder.industries.length || !this.purchaseOrder.excellenceCenters.length || !this.purchaseOrder.supportCenters.length);
    };

    setObjectApportionment(objectApportionment) {
        this.objectApportionment = objectApportionment;
        this.sendModalApportionment();
    }

    sendModalApportionment() {
        let itemsPurchaseOrderIndustries = [];
        this.itemsPurchaseOrder.forEach(item => {
            if (item.customer && (item.customer.industry && item.customer.industry._id)) {
                itemsPurchaseOrderIndustries.push({
                    ...item.customer.industry,
                    percentage: parseFloat(item.percentage),
                    value: item.value
                })
            }
        })
        this.apportionment = {
            industries: this.apportionment.industries ? [...this.purchaseOrder.industries] : [...itemsPurchaseOrderIndustries],
            excellenceCenters: [...this.purchaseOrder.excellenceCenters],
            supportCenters: [...this.purchaseOrder.supportCenters]
        }
    }

    getApportionment(apportionment: Ratio){
        const fields = ['industries', 'excellenceCenters', 'supportCenters'];
        let distributionRatio = {...apportionment};
        fields.forEach(field => {
            distributionRatio[field] = distributionRatio[field].reduce((acc: Dimension[], item: Dimension) => {
                if (item.percentage > 0) {
                    acc.push(item);
                }
                return acc;
            }, [])
        })
        this.purchaseOrder.excellenceCenters = [...distributionRatio.excellenceCenters];
        this.purchaseOrder.supportCenters = [...distributionRatio.supportCenters];
        this.purchaseOrder.industries = [...distributionRatio.industries];
    };

    checkBlockPeriod() {

    }

    isPurchaseOrderValueNan(value: number) {
        return isNaN(value);
    }
}



// WEBPACK FOOTER //
// ./src/app/views/purchase-order/purchase-order-create/purchase-order-create.component.ts